import Image from "next/image";
import React, { useRef } from "react";
import AssociatedLogo1 from "@/public/logo/associated1.png";
import AssociatedLogo2 from "@/public/logo/associated2.png";
import AssociatedLogo3 from "@/public/logo/associated3.png";
import CertifiedLogo1 from "@/public/logo/certified.png";
type Props = {};

export default function PartnerHome({}: Props) {
  return (
    <div className="relative w-11/12 lg:w-10/12 mx-auto md:py-[3rem] py-6  flex justify-center items-center">
      <div className="flex md:flex-row flex-col justify-center gap-10  z-20">
        <div className="flex flex-col md:flex-row  gap-3 justify-center items-center">
          <span className="flex gap-2 text-black text-lg md:text-xl title font-semibold items-center">
            <span className="text-nowrap">Associated with</span>{" "}
          </span>
          <div className="flex flex-wrap gap-1 justify-center items-center">
            <Image
              src={AssociatedLogo1}
              alt="logo"
              className="overflow-hidden md:h-[5.5rem] md:w-[5.5rem] h-10 w-10 object-cover object-center"
            ></Image>
            <Image
              src={AssociatedLogo2}
              alt="logo"
              className="overflow-hidden  md:h-[5.5rem] md:w-[5.5rem] h-10 w-10 object-cover object-center"
            ></Image>
         
          </div>
        </div>

        <div className="flex flex-col md:flex-row  gap-3 justify-start md:justify-center items-center">
          <span className="flex gap-2 text-black text-lg md:text-xl title font-semibold items-center">
            Professional Association{" "}
          </span>
          <div className="flex gap-1 justify-center items-center">
            <Image
              src={CertifiedLogo1}
              alt="logo"
              className="overflow-hidden md:h-[5.5rem] md:w-[5.5rem] h-10 w-10 object-cover object-center"
            ></Image>
          </div>
        </div>
      </div>
    </div>
  );
}
